const ProposalApplicationStatusEnum = Object.freeze({
    PENDING: 'PENDING',
    SENT: 'SENT',
    SIGNED: 'SIGNED',
    EXPIRED: 'EXPIRED',
    ABORTED: 'ABORTED'
});

export default ProposalApplicationStatusEnum;
